// main.js
import { createApp } from 'vue'
import App from '@v/athleticsApp.vue'

function initAthleticsFeed() {
    const app = createApp(App)
    app.mount('#athletics-feed-component-fetch')
}

// Make it globally available
window.initAthleticsFeed = initAthleticsFeed;

// Re-run whenever Sprig/htmx swaps in new content that might contain a player
document.body.addEventListener('htmx:afterSwap', (e) => {
    // Check if the swapped content (or its children) has the video element
    if (e.detail.target.matches('#athletics-feed-component-fetch') || e.detail.target.querySelector('#athletics-feed-component-fetch')) {
        initAthleticsFeed();
    }
});

// Also run once on initial load
document.addEventListener('DOMContentLoaded', initAthleticsFeed);